import { Parcel, SoilZones, Objective, OptimizerResult } from '../types';
import { CLASSES, RULES, SOIL_MOD } from '../constants/landUseConfig';
import { computeMetrics } from './metricsCalculator';

function objectiveValue(objective: Objective, cls: string, factor: number): number {
  const rule = RULES[cls];
  if (objective === 'revenue') return rule.econ * factor;
  if (objective === 'ghg') return -rule.carbon * factor;
  if (objective === 'bio') return rule.bio * factor;
  return 0;
}

export function runOptimizer(
  baselinePolygons: Parcel[],
  baselineSoil: SoilZones,
  objective: Objective,
  maxPct: number,
  excludedClasses: Set<string> = new Set() // ADD THIS PARAMETER
): OptimizerResult {
  const candidates = baselinePolygons
    .filter((p) => !excludedClasses.has(p.cls)) // ADD THIS LINE - skip excluded classes
    .map((p) => {
      const soil = baselineSoil[p.soilZone];
      const currentFactor = 1 + SOIL_MOD[p.cls][soil] / 100;
      const currentVal = objectiveValue(objective, p.cls, currentFactor);

      let bestCls: string | null = null;
      let bestVal = currentVal;

      CLASSES.forEach((c) => {
        if (c.id === p.cls) return;
        const f = 1 + SOIL_MOD[c.id][soil] / 100;
        const v = objectiveValue(objective, c.id, f);
        if (v > bestVal) {
          bestVal = v;
          bestCls = c.id;
        }
      });

      const gainTotal = bestCls ? (bestVal - currentVal) * p.areaHa : 0;
      return { id: p.id, bestCls, gainTotal };
    })
    .filter((c) => c.bestCls && c.gainTotal > 0)
    .sort((a, b) => b.gainTotal - a.gainTotal);

  const cap = Math.floor((maxPct / 100) * baselinePolygons.length);
  const chosen = candidates.slice(0, cap);
  const chosenMap = Object.fromEntries(
    chosen.map((c) => [c.id, c.bestCls!])
  );

  const optimizedParcels = baselinePolygons.map((p) =>
    chosenMap[p.id] ? { ...p, cls: chosenMap[p.id] } : p
  );

  const before = computeMetrics(baselinePolygons, baselineSoil);
  const after = computeMetrics(optimizedParcels, baselineSoil);

  return {
    optimizedParcels,
    changedIds: new Set(chosen.map((c) => c.id)),
    before,
    after,
  };
}